var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FF6960"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 45.3346C39.3332 45.3346 45.3332 39.3346 45.3332 32.0013C45.3332 24.668 39.3332 18.668 31.9998 18.668C24.6665 18.668 18.6665 24.668 18.6665 32.0013C18.6665 39.3346 24.6665 45.3346 31.9998 45.3346Z",
    stroke: "#F1F5F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.668V33.3346",
    stroke: "#F1F5F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9927 37.332H32.0047",
    stroke: "#F1F5F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/rejectIcon.13b91da4ad474c51064b595f2b4a6ce4.svg";
export { ForwardRef as ReactComponent };